import { useMemo } from "react";
import { useProductsDataQuery } from "../../products/queries/useProductsQuery";
import { useCategoriesQuery } from "../../categories/queries/useCategoriesQuery";
import { ProductInterface } from "../../../interfaces/productInterface";
import { CategoryInterface } from "../../../interfaces/categoryInterface";

type ReturnType = {
  targetItems: ProductInterface[] | CategoryInterface[];
  isLoading: boolean;
};

export const useTargetData = (
  discountTarget: "product-category" | "product",
): ReturnType => {
  const { data: productsData, isLoading: productsIsLoading } =
    useProductsDataQuery({ enabled: discountTarget === "product" });
  const { data: categoriesData, isLoading: categoriesIsLoading } =
    useCategoriesQuery({
      enabled: discountTarget === "product-category",
    });

  const targetItems = useMemo(() => {
    if (discountTarget === "product-category") {
      return categoriesData?.data ?? [];
    }
    return productsData?.data ?? [];
  }, [discountTarget, categoriesData, productsData]);

  return {
    targetItems,
    isLoading: productsIsLoading || categoriesIsLoading,
  };
};
